import { hydrateWidgets } from '@utils';
import { PaymentStateMsg } from '../../widgets/DVWebNodePaymentStateMessaging';
hydrateWidgets(PaymentStateMsg);
